import { SkeletonBlock } from '~/shared/ui'

export function LoadingSkeleton() {
  return (
    <div className="flex items-center justify-between px-6 py-3">
      <div className="flex items-center gap-4">
        <SkeletonBlock className="h-12 w-[240px]" />
      </div>
      <SkeletonBlock className="h-9 w-[180px]" />
    </div>
  )
}
